import { memo, useState } from 'react'
import { useTranslations } from '@/core/translation'
import { summaryCardActionsStyles as styles } from './SummaryCardActions.style'
import { Box } from '@/components/Layout'
import { Button } from '@/components/Inputs'
import { ConfirmationModal } from '@/components/Surface'
import { CONFIRMATION_MODAL_TYPE } from './SummaryCardActions.data'
import { ConfirmationModalType } from './SummaryCardActions.types'

export interface SummaryCardActionProps {
  onEditClick: () => void
  onRemoveClick?: () => void
  isActionDisabled?: boolean
  isRemoveActionDisabled?: boolean
}

function SummaryCardActions({
  onEditClick,
  onRemoveClick,
  isActionDisabled = false,
  isRemoveActionDisabled = false,
}: SummaryCardActionProps) {
  const t = useTranslations('cart')
  const [open, setOpen] = useState<ConfirmationModalType | null>(null)

  return (
    <>
      <Box sx={styles.buttonWrapper}>
        <Button
          color="tertiary"
          sx={styles.button}
          textProps={{ sx: styles.buttonText }}
          size="small"
          noBorder
          disabled={isActionDisabled}
          onClick={() => setOpen(CONFIRMATION_MODAL_TYPE.EDIT)}>
          {t('edit')}
        </Button>
        <Button
          color="tertiary"
          sx={styles.button}
          textProps={{ sx: styles.buttonText }}
          size="small"
          noBorder
          disabled={isRemoveActionDisabled || isActionDisabled}
          onClick={() => setOpen(CONFIRMATION_MODAL_TYPE.REMOVE)}>
          {t('remove')}
        </Button>
      </Box>
      <ConfirmationModal
        open={open !== null}
        title={
          open === CONFIRMATION_MODAL_TYPE.EDIT ? t('modifyConfirmation') : t('removeConfirmation')
        }
        onCancelClick={() => setOpen(null)}
        onConfirmClick={() => {
          if (open === CONFIRMATION_MODAL_TYPE.EDIT) onEditClick()
          if (open === CONFIRMATION_MODAL_TYPE.REMOVE) onRemoveClick?.()
          setOpen(null)
        }}
      />
    </>
  )
}

export default memo(SummaryCardActions)
